import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function MailIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>E-Mail</title>;
    t3 = <path d="M22,3H2A1,1,0,0,0,1,4V20a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V4A1,1,0,0,0,22,3ZM17.5859,5,12,10.5859,6.4141,5ZM21,19H3V5h.5859l7.7071,7.707a.9995.9995,0,0,0,1.414,0L20.4141,5H21Z" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className || $[7] !== color || $[8] !== props) {
    t4 = <svg className={className} fill={color} height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}</svg>;
    $[6] = className;
    $[7] = color;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}